export default "__VITE_ASSET__7b9a7561__"